import React from 'react';
function VideoPlayIcon() {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="24" height="24" rx="12" fill="black" fillOpacity="0.72" />
      <path
        d="M16.9609 10.5391C17.2891 10.75 17.5 11.125 17.5 11.5C17.5 11.8984 17.2891 12.2734 16.9609 12.4609L10.2109 16.5859C9.85938 16.7969 9.41406 16.8203 9.0625 16.6094C8.71094 16.4219 8.5 16.0469 8.5 15.625V7.375C8.5 6.97656 8.71094 6.60156 9.0625 6.41406C9.41406 6.20312 9.85938 6.20312 10.2109 6.4375L16.9609 10.5391Z"
        fill="white"
      />
    </svg>
  );
}

export default VideoPlayIcon;
